<template>
  <div class="bill-container main-body">
    <div class="bill-Pay-header">
      <span>账户余额：{{ remainingSum['surplus'] || '**************' }}</span>
      <el-button type="primary" @click="supplementPointsFn" v-if="!isSuperAdmin">充值</el-button>
    </div>
    <el-tabs type="border-card" class="bill-Pay-tabs">
      <el-tab-pane label="消费记录">
        <div class="bill-Pay-list">
          <div style="height: calc(100% - var(--pageHeight))">
            <el-scrollbar height="100%">
              <div class="bill-Pay-item" v-for="(item, index) in tableList" :key="index">
                <div class="bill-Pay-item-time">{{ item['buyTime'] }}</div>
                <div class="bill-Pay-item-info ellipsis" :title="item['refer']">{{ item['refer'] }}</div>
                <div class="bill-Pay-item-type">{{ item['buyType'] }}</div>
                <div class="bill-Pay-item-integral">{{ item['useIntegral'] }}</div>
              </div>
            </el-scrollbar>
          </div>
          <div class="page-body">
            <Pagination @pageChange="pageChange" :total="total" v-model:page="listQuery.page"
              v-model:limit="listQuery.limit" />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="充值记录">
        <RechargeRecord />
      </el-tab-pane>
    </el-tabs>
    <CreateOrder v-if="createOrderFlag" @close="createOrderFlagClose" />
  </div>
</template>


<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';

import TableCom from '@/components/TableCom';
import Pagination from '@/components/Pagination';
import ButtonList from '@/components/ButtonList';

import CreateOrder from './component/CreateOrder';
import RechargeRecord from './component/RechargeRecord';


// props
const props = defineProps({

});
// emit
const emit = defineEmits([

]);
const isSuperAdmin = computed(() => store.getters['isSuperAdmin']);
const createOrderFlag = ref(false),
  createOrderFlagChange = (flag) => {
    createOrderFlag.value = flag;
  },
  createOrderFlagClose = () => {
    createOrderFlagChange(false);
  }

const searchFun = (target, button, loadFn) => {
  selectList();
  loadFn();
}
// 需要序号可添加
const tableNumber = (number) => {
  return (listQuery.page - 1) * listQuery.limit + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, },

]);
const buttonTarget = ref({});
const buttonList = ref([

]);
const tableList = ref([]);
let total = ref(0),
  listQuery = reactive({
    page: 1,
    limit: 20,
  });
// 分页器change
const pageChange = () => {
  selectList();
}

const selectList = () => {
  getList(listQuery).then(res => {
    if (res.data.code == 1004) {
      tableList.value = res.data.data;
      total.value = res.data.count;
    }
  }).catch(err => {
    console.log(err);
  });
}


const supplementPointsFn = () => {
  createOrderFlagChange(true);
  // supplementPoints({}).then(res=>{
  //   if(res.data.code == 1004){
  //     message(res.data.msg, 1);
  //     getPersonIntegralFn();
  //   }
  // }).catch(err=>{
  //   console.log(err);
  // });
}

const remainingSum = ref({}),
  getPersonIntegralFn = () => {
    getPersonIntegral({}).then(res => {
      if (res.data.code == 1004) {
        remainingSum.value = res.data.data;
      }
    }).catch(err => {
      console.log(err);
    });
  }
// 组件挂载前
onBeforeMount(() => {

});
// 组件挂载后
onMounted(() => {
  selectList();
  getPersonIntegralFn();
});
// 组件更新后
onUpdated(() => {

});
// 组件销毁后
onUnmounted(() => {

});
</script>

<style lang='less'></style>

<style lang='less' scoped>
.bill-container {
  --payHeaderHeight: 120px;
  padding: 10px;

  .bill-Pay-header {
    height: var(--payHeaderHeight);
    border-bottom: 1px solid var(--el-border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 25px;
      font-family: OPPOSans-R;
      color: var(--fontColor_5);
    }

    :deep(.el-button) {
      border-radius: 0;
      background-color: var(--backgroundColor_23);
      color: var(--fontColor_8);
      border: none;
      width: 240px;
      height: 60px;
      font-family: OPPOSans-H;
      font-size: 25px;
      font-weight: bold;
    }
  }

  .bill-Pay-tabs {
    height: calc(100% - var(--payHeaderHeight));

    .el-tabs__content {
      .el-tab-pane {
        height: 100%;
      }
    }
  }

  .bill-Pay-list {
    height: 100%;
    padding: 5px;

    .bill-Pay-item {
      width: 100%;
      height: 40px;
      background-color: var(--backgroundColor_25);
      margin-bottom: 8px;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      display: flex;
      align-items: center;

      div {
        text-align: center;
      }

      .bill-Pay-item-time {
        width: 200px;
      }

      .bill-Pay-item-info {
        min-width: 0;
        flex: 1;
        text-align: left;
      }

      .bill-Pay-item-type {
        width: 100px;
      }

      .bill-Pay-item-integral {
        width: 100px;
      }
    }
  }
}
</style>